import React from 'react';
import FormsComponent from '../../../components/ProfileCard/Forms/Forms';

import { Form } from 'antd';
import moment from 'moment';

class FormsData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
    };

    this.defaultProfileData = {};

    this.flagInitEditing = false;
    this.roleKey = null;
  }

  componentDidMount() {
    this.initEditing();
    // this.updateProgressAllEditForm();
  }

  componentDidUpdate(prevProps, prevState) {
    this.initEditing();
    //if (this.props.checkFormErrors) {
    //  this.props.checkFormErrors(this.props.name);
    //}
  }

  initEditing = () => {
    let { isEditable } = this.props;
    let dataProps = this.props.data;
    if (!this.flagInitEditing && isEditable) {
      this.flagInitEditing = true;

      let newEditData = {};
      if (dataProps) {
        Object.keys(dataProps).forEach(item => {
          newEditData[item] = {
            value: dataProps[item],
          };
        });
      }
      this.setState({ data: newEditData }, () => {
        this.roleKey = newEditData.roleKey && newEditData.roleKey.value;
        this.props.handleChangeUserRole(this.roleKey);
        // проверить все поля на валидность
        if (this.formRef) {
          this.formRef.validateFields((errors, values) => {
            this.changeValues(values);
          });
        }
      });
    } else if (!isEditable && this.flagInitEditing) {
      this.flagInitEditing = false;
    }
  };

  changeValues = values => {
    if (this.formRef) {
      Object.keys(values).forEach(name => {
        if (name === 'roleKey') {
          let newRoleKey = this.formRef.getFieldValue(name);
          if (this.roleKey !== newRoleKey) {
            this.roleKey = newRoleKey;
            this.props.handleChangeUserRole(this.roleKey);
          }
        }
        if (name === 'phone' || name === 'phoneCode') {
          this.props.changePhone();
        }
        // изменилось поле в котором была серверная ошибка
        if (
          this.props.dataErr &&
          this.props.dataErr.data &&
          this.props.dataErr.data.key === name
        ) {
          this.formRef.setFields({
            [name]: {
              ...values[name],
              errors: null,
            },
          });
          this.props.createEmployeeClearError();
        }
      });
      // Обновляем прогресс заполнения
      this.props.updateProgress(values);
    }
  };

  handleFieldsChange = values => {
    this.setState(
      state => ({
        data: {
          ...state.data,
          ...values,
        },
      }),
      () => {
        this.changeValues(values);
      }
    );
  };

  validateField = nameField => {
    let result =
      this.formRef &&
      this.formRef.isFieldTouched(nameField) &&
      this.formRef.getFieldError(nameField);
    // todo Проверить есть ли в сторе ошибки от сервера
    //let err = 'Уже есть такой пользователь';
    //if(nameField === 'phone')
    return {
      status: result ? 'error' : '',
      help: result || '',
    };
  };

  getValueByFieldName(name, val) {
    if (name.includes('Date')) {
      return (val && moment(val)) || null;
    } else {
      return val;
    }
    /*
    switch (name) {
      case 'birthDate':
        return (val && moment(val)) || null;
      case 'driverLicenseEndDate':
        return (val && moment(val)) || null;
      default:
        if(name.includes('driverLicenseСategoryStartDate') || name.includes('tachographСardsEndDate')) {
          return (val && moment(val)) || null;
        }
        return val;
    }
    */
  }

  filterOption = (input, option) => {
    return (
      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    );
  };

  formSubmit = () => {
    if (this.formRef) {
      this.formRef.validateFields((err, values) => {
        console.log('Ошибки', err, values);
      });
    }
  };
  saveFormRef = formRef => {
    if (formRef && formRef.props && formRef.props.form) {
      this.formRef = formRef.props.form;
    } else {
      this.formRef = null;
    }
    this.props.setForm(this.props.name, this.formRef);
  };

  render() {
    const { isEditable } = this.props;

    const data = isEditable
      ? this.state.data
      : this.props.data || this.defaultProfileData;
    /* 
            const {  userIsDriver,
            userIsDriverInEditForm, } = this.props;
            const isDriver = isEditable ? userIsDriverInEditForm : userIsDriver;
        */
    return (
      <FormProfileCard
        {...this.props}
        wrappedComponentRef={this.saveFormRef}
        handleFieldsChange={this.handleFieldsChange}
        getValueByFieldName={this.getValueByFieldName}
        validateField={this.validateField}
        filterOption={this.filterOption}
        formSubmit={this.formSubmit}
        data={data}
      />
    );
  }
}

const FormProfileCard = Form.create({
  name: 'profileCard',
  onFieldsChange(props, changedFields) {
    if (props.isEditable) {
      let flagUpdate = !Object.keys(changedFields).some(key => {
        return changedFields[key].validating;
      });
      if (flagUpdate) props.handleFieldsChange(changedFields);
      /*props.handleFieldsChange(changedFields);*/
    }
  },
  mapPropsToFields(props) {
    let obj = {};
    Object.keys(props.data).forEach(name => {
      obj[name] = Form.createFormField({
        ...(props.isEditable ? props.data[name] : {}),
        value: props.getValueByFieldName(
          name,
          props.isEditable ? props.data[name].value : props.data[name]
        ),
      });
    });

    let err = {};
    if (
      props.dataErr &&
      props.dataErr.data &&
      props.dataErr.data.key &&
      props.dataErr.data.message
    ) {
      err.errors = [new Error(props.dataErr.data.message)];
      err.touched = true;
      if (obj[props.dataErr.data.key]) {
        obj[props.dataErr.data.key] = Form.createFormField({
          ...obj[props.dataErr.data.key],
          ...(props.isEditable ? err : {}),
        });
      } else {
        obj[props.dataErr.data.key] = Form.createFormField({
          value: undefined,
          ...(props.isEditable ? err : {}),
        });
      }
    }
    return obj;
  },
  onValuesChange() {},
})(FormsComponent);

export default FormsData;
